export const CREATE_LOTTERY_ERROR = 'CREATE_LOTTERY_ERROR';
export const CREATE_LOTTERY_SUCCESS = 'CREATE_LOTTERY_SUCCESS';

export const REQUEST_DELETE_LOTTERIES = 'REQUEST_DELETE_LOTTERIES';
export const DELETE_LOTTERIES_ERROR = 'DELETE_LOTTERIES_ERROR';
export const DELETE_LOTTERIES_SUCCESS = 'DELETE_LOTTERIES_SUCCESS';

export const DELETE_LOTTERY_ERROR = 'DELETE_LOTTERY_ERROR';
export const DELETE_LOTTERY_SUCCESS = 'DELETE_LOTTERY_SUCCESS';

export const UPDATE_LOTTERY_ERROR = 'UPDATE_LOTTERY_ERROR';
export const UPDATE_LOTTERY_SUCCESS = 'UPDATE_LOTTERY_SUCCESS';

export const LOAD_LOTTERIES_SUCCESS = 'LOAD_LOTTERIES_SUCCESS';
export const UNLOAD_LOTTERIES_SUCCESS = 'UNLOAD_LOTTERIES_SUCCESS';

export const REQUEST_SELECT_WINNER = 'REQUEST_SELECT_WINNER';
export const SELECT_WINNER_SUCCESS = 'SELECT_WINNER_SUCCESS';
export const SELECT_WINNER_ERROR = 'SELECT_WINNER_ERROR';

export const REQUEST_CLEAR_LOTTERIES = 'REQUEST_CLEAR_LOTTERIES';
export const CLEAR_LOTTERIES_ERROR = 'CLEAR_LOTTERIES_ERROR';
export const CLEAR_LOTTERIES_SUCCESS = 'CLEAR_LOTTERIES_SUCCESS';

export const START_DRAM_ROLL = 'START_DRAM_ROLL';
export const FINISH_DRAM_ROLL = 'FINISH_DRAM_ROLL';

export const FINISH_WIN_ANIMATION = 'FINISH_WIN_ANIMATION';

export const SHOW_SNAK_BAR = 'SHOW_SNAK_BAR';
export const HIDE_SNAK_BAR = 'HIDE_SNAK_BAR';

export const UPDATE_NUMBER_OF_WINNER = 'UPDATE_NUMBER_OF_WINNER';



// WEBPACK FOOTER //
// ./src/core/lotteries/action-types.js